import React from "react";
import { MUIBox, tokens } from "@cobee/cobee-ui";
import { translate as t } from "infrastructure/translate/localization";
import { Typography } from "@material-ui/core";

export default function DeliveriesEmptyState() {
  return (
    <MUIBox mt={3}>
      <Typography style={tokens.typography["Body-M-400"]}>
        {t("subsidy-section.no-deliveries-available")}
      </Typography>
    </MUIBox>
  );
}
